
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand-story",
      function () {
        return require("private-next-pages/brand-story/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand-story"])
      });
    }
  